import { controversies } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function InsideStories() {
  return (
    <section id="inside" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="text-xs font-bold tracking-[0.3em] text-primary-600 md:text-sm">INSIDE</span>
              <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
                内幕争议 · 说法与真相对照
              </h2>
            </div>
            <span className="inline-flex w-fit items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4 py-2 text-xs font-medium text-foreground-700 md:text-sm">
              <i className="ri-information-line text-base text-accent-600" />
              标注"待核实"的说法仅供参考，不作定论
            </span>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 md:mt-12 md:grid-cols-2 md:gap-5">
          {controversies.map((item, index) => (
            <Reveal key={item.claim} delay={index * 60}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-secondary-300 md:p-6">
                <div className="flex items-start justify-between gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 md:h-12 md:w-12">
                    <i className={`${item.icon} text-xl md:text-2xl`} />
                  </span>
                  <span
                    className={`rounded-full px-3 py-1 text-[11px] font-bold ${
                      item.verified
                        ? 'bg-secondary-100 text-secondary-800'
                        : 'bg-accent-100 text-accent-800'
                    }`}
                  >
                    {item.verified ? '已澄清' : '待核实'}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-base font-bold leading-relaxed text-foreground-950 md:text-lg">
                  {item.claim}
                </h3>
                <p className="mt-3 border-l-2 border-primary-300 pl-3 text-sm leading-relaxed text-foreground-600">
                  {item.answer}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}